import { ResizableHandle } from "@/components/flexkit/Resizable";
import { cn } from "@/components/podkit/lib/cn";
import { useMemo, type FC } from "react";
import { useDesktop } from "@/hooks/use-desktop";
import { ResizableSidebar, SidebarFooter } from "@/components/SidebarLayout";
import { settingsRoutes } from "@/app";
import type { MenuItem } from "@/menu-item";
import { populateMenuFromRoute } from "@/menu-item";
import { SettingsMenu } from "@/components/settings/SettingsMenu";
import { Link } from "@/components/flexkit/Link";
import { IconArrowLeft } from "@/assets/icons/geist/IconArrowLeft";
import { ScrollArea } from "@/components/flexkit/ScrollArea";
import { KeyboardKey } from "@/components/KeyboardKey";
import { Tooltip } from "@/components/Tooltip";

export const SettingsSidebar: FC = () => {
    const { isDesktop } = useDesktop();
    return (
        <ResizableSidebar>
            <div
                data-testid="sidebar"
                className={cn("flex h-dvh w-full flex-col pb-[6px] pl-2 pt-4", {
                    "pt-10": isDesktop,
                })}
            >
                <div className="pl-2 pr-2">
                    <SidebarHeader />
                </div>
                <ScrollArea orientation="vertical" className="mr-0.5 flex-grow pt-2">
                    <SidebarContent />
                </ScrollArea>
                <div className="pb-2">
                    <SidebarFooter />
                </div>
            </div>
            <ResizableHandle className="top-[16px] mr-[1px] h-[calc(100dvh-32px)]" />
        </ResizableSidebar>
    );
};

const SidebarHeader: FC = () => {
    return (
        <Tooltip
            content={
                <div className="flex flex-row items-center gap-2">
                    Back to Gitpod
                    <KeyboardKey className="bg-surface-invert-tertiary">Esc</KeyboardKey>
                </div>
            }
        >
            <Link
                className="flex h-8 flex-row items-center gap-1 rounded-lg pl-2 hover:bg-surface-03"
                to="/"
                reloadIfFrontendUpdated={true}
            >
                <div className="w-5">
                    <IconArrowLeft size="base" />
                </div>

                <div className={cn("flex-grow truncate text-start text-base font-bold")}>Back to Gitpod</div>
            </Link>
        </Tooltip>
    );
};

const SidebarContent: FC = () => {
    const menu: MenuItem[] = useMemo(() => populateMenuFromRoute(settingsRoutes), []);
    return <SettingsMenu menu={menu} />;
};
